<template>
  <div class="account-type">
    <HelpTip v-bind="labelInfo"></HelpTip>
    <div class="account-type-content">
      <TempSelect
        class="account-type-content-select"
        :formData="formData[id]"
        id="thirdType"
        :customKey="thirdTypeCustomKey"
      ></TempSelect>
      <TempInput
        class="account-type-content-input"
        :formData="formData[id]"
        id="account"
        :required="labelInfo.required"
        :label="labelInfo.label"
      ></TempInput>
    </div>
  </div>
</template>

<script>
import workTemp from '@mixins/officialSupport/workTemp';
import TempInput from '@components/officialSupport/workTemp/TempInput.vue';
import TempSelect from '@components/officialSupport/workTemp/TempSelect.vue';
export default {
  name: 'TempOrder',
  mixins: [workTemp],
  created() {
    this.$set(this.formData[this.id], 'account', null);
    this.$set(this.formData[this.id], 'thirdType', null);
  },
  data() {
    return {
      thirdTypeCustomKey: {
        defaultValue: 'Facebook',
        options: [
          {
            label: 'Facebook',
            value: 'Facebook'
          },
          {
            label: 'Twitter',
            value: 'Twitter'
          },
          {
            label: 'Naver',
            value: 'Naver'
          },
          {
            label: 'VK',
            value: 'VK'
          },
          {
            label: 'OneStore',
            value: 'OneStore'
          },
          {
            label: 'Email',
            value: 'Email'
          },
          {
            label: 'Discord',
            value: 'Discord'
          },
          {
            label: 'GooglePlay',
            value: 'GooglePlay'
          },
          {
            label: 'Apple',
            value: 'Apple'
          },
          {
            label: 'GameCenter',
            value: 'GameCenter'
          },
          {
            label: 'PGS',
            value: 'PGS'
          },
          {
            label: 'Line',
            value: 'Line'
          },
          {
            label: 'Kakao',
            value: 'Kakao'
          }
        ]
      }
    };
  },
  components: {
    TempInput,
    TempSelect
  }
};
</script>

<style lang="scss" scoped>
.account-type-content {
  display: flex;
  &-select {
    width: 50%;
    margin-right: 10px;
  }
  &-input {
    width: 50%;
  }
}
</style>
